<mat-card class="filter-card">
    <mat-card-content>
        <div class="row">
            <mat-form-field appearance="outline" class="padding-x wide">
                <mat-icon matPrefix>search</mat-icon>
                <input matInput [(ngModel)]="stringFilter" (ngModelChange)="onStringFilter($event)"
                    placeholder="Rechercher une promotion" class="center-input">
            </mat-form-field>

            @if (isFiltered()) {
            <button mat-stroked-button class="padding-x" aria-label="Clear" (click)="clearFilters()">
                <mat-icon>filter_alt_off</mat-icon>Effacer tous les filtres
            </button>
            }
        </div>
        <div class="row">
            <mat-form-field appearance="outline" class="padding-x">
                <mat-label>Selectionné</mat-label>
                <mat-select [(ngModel)]="selectionFilter" (selectionChange)="onSelectChange($event.value)">
                    <mat-option value="">Tous</mat-option>
                    <mat-option value="true">Oui</mat-option>
                    <mat-option value="false">Non</mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline" class="padding-x" density="-2">
                <mat-label>Mode de compensation</mat-label>
                <mat-select [(ngModel)]="modeCompensationFilter"
                    (selectionChange)="onModeCompensationChange($event.value)">
                    <mat-option value="">Tous</mat-option>
                    @for(modeCompensation of modeCompensationList; track modeCompensation) {
                    <mat-option value="{{modeCompensation}}">{{modeCompensation}}</mat-option>
                    }
                </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline" class="padding-x dense">
                <mat-label>Statut</mat-label>
                <mat-select [(ngModel)]="statutFilter" (selectionChange)="onStatutChange($event.value)">
                    <mat-option value="">Tous</mat-option>
                    @for(statut of statutList; track statut) {
                    <mat-option value="{{statut}}">{{statut}}</mat-option>
                    }
                </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline" class="align-date dense">
                <mat-label>Période</mat-label>
                <mat-date-range-input [formGroup]="period" [rangePicker]="periodPicker" class="center-input">
                    <input matStartDate (ngModelChange)="onPeriodeChange()" placeholder="Début" formControlName="start">
                    <input matEndDate (ngModelChange)="onPeriodeChange()" placeholder="Fin" formControlName="end">
                </mat-date-range-input>
                <mat-date-range-picker #periodPicker></mat-date-range-picker>
            </mat-form-field>
            <div class="calendar-toggle">
                <mat-datepicker-toggle matIconSuffix [for]="periodPicker"></mat-datepicker-toggle>
            </div>
        </div>
        <div class="row">
            <button mat-stroked-button class="padding-x" aria-label="Selected and in progress"
                [class]="(selectionFilter==='true' && statutFilter==='En Cours' && modeCompensationFilter === '')?'active':''"
                (click)="applyRequestFilter({'isSelected': true, 'statut':'En Cours'})">
                <mat-icon>filter_alt</mat-icon>Promotions Sélectionnées et En cours
            </button>
            <button mat-stroked-button class="padding-x" aria-label="Selected and not started"
                aria-label="Selected and not started"
                [class]="(selectionFilter==='true' && statutFilter==='Non commencée' && modeCompensationFilter === '')?'active':''"
                (click)="applyRequestFilter({'isSelected': true, 'statut':'Non commencée'})">
                <mat-icon>filter_alt</mat-icon>Promotions Sélectionnées et Non commencées
            </button>
        </div>
    </mat-card-content>
</mat-card>